import React from 'react';

const AdminPortrait = () => (
  <div className="admin-portrait">
    <h3>Portrait Video Management</h3>
    <p>Manage portrait videos (reels) — UI to be implemented.</p>
  </div>
);

export default AdminPortrait;
